// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__sNzue","row":"ProcedureTreatmentSummary_row__5RCo0"};